// The permissions the panel knows. What each one guards is decided where it is used: routes.tsx for
// views, the host slices for action flags. Who holds them is app-service's call.
export const PERMISSIONS = {
  'care.search': 'The search and every action on its results',
  'operations.amazon_door_access': 'The Amazon Access location gate: reads and batch writes',
  'operations.carrier_exclusion_lists': 'The carriers\' exclusion lists of registered «Usuarios»: list, add, remove',
} as const;

export type Permission = keyof typeof PERMISSIONS;

const KNOWN: ReadonlySet<string> = new Set(Object.keys(PERMISSIONS));

export function isKnownPermission(id: string): id is Permission {
  return KNOWN.has(id);
}

// Deny by default: an identifier the panel does not know grants nothing.
export function can(granted: readonly string[], permission: Permission): boolean {
  return isKnownPermission(permission) && granted.includes(permission);
}

export function hasAnyKnownPermission(granted: readonly string[]): boolean {
  return granted.some(isKnownPermission);
}

// The booleans a business slice receives as props; slices never see permissions themselves.
export function actionFlags<Flag extends string>(
  granted: readonly string[],
  required: Record<Flag, Permission>,
): Record<Flag, boolean> {
  const flags = {} as Record<Flag, boolean>;
  for (const flag of Object.keys(required) as Flag[]) {
    flags[flag] = can(granted, required[flag]);
  }
  return flags;
}
